import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FaInfoCircle } from 'react-icons/fa';
import LocaleFormat from '../../commons/utils/LocaleFormat.js';

const PresupuestoDetail = ({ presupuesto, relacion }) => {
    const {
        monto_general = 0,
        monto_correctivo = 0,
        monto_preventivo = 0,
        monto_gestoria = 0,
        monto_vencimientos = 0,
        resumen = {},
    } = presupuesto;

    const totalAsignado = monto_general + monto_correctivo + monto_preventivo + monto_gestoria + monto_vencimientos;
    const distribuido = parseFloat(resumen.distribuido) || 0;
    const comprometido = parseFloat(resumen.comprometido) || 0;
    const consumido = parseFloat(resumen.consumido) || 0;
    const disponible = relacion.modulo !== 'bases'
        ? totalAsignado - distribuido
        : totalAsignado - (comprometido + consumido);

    const formatCurrency = (value) =>
        new Intl.NumberFormat(LocaleFormat.getNumberLocale(), { style: 'currency', currency: 'ARS' }).format(value);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f9f9f9', width: '100%' }}>
            <div style={{ margin: '10px', padding: '20px', backgroundColor: '#ffffff', border: '1px solid rgb(0, 191, 188)', borderRadius: '10px', width: '95%', textAlign: 'center', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }}>
                <h2 style={{ marginBottom: '20px', color: 'rgb(0, 191, 188)', fontSize: '20px', textAlign: 'left' }}>{presupuesto.periodo.nombre}</h2>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '16px', tableLayout: 'fixed' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '10px', fontWeight: 'bold', textAlign: 'left', whiteSpace: 'nowrap' }}>
                                <FormattedMessage id="presupuestoDetail.presupuesto_table.column_fecha_inicio" defaultMessage="Fecha de inicio" />
                            </td>
                            <td style={{ padding: '10px', textAlign: 'left', whiteSpace: 'nowrap' }}>{presupuesto.periodo ? presupuesto.periodo.fecha_inicio : 'N/A'}</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '10px', fontWeight: 'bold', textAlign: 'left', whiteSpace: 'nowrap' }}>
                                <FormattedMessage id="presupuestoDetail.presupuesto_table.column_fecha_fin" defaultMessage="Fecha de fin" />
                            </td>
                            <td style={{ padding: '10px', textAlign: 'left', whiteSpace: 'nowrap' }}>{presupuesto.periodo ? presupuesto.periodo.fecha_fin : 'N/A'}</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '10px', fontWeight: 'bold', textAlign: 'left', whiteSpace: 'nowrap' }}>
                                <FormattedMessage id="presupuestoDetail.presupuesto_table.column_total_asignado" defaultMessage="Presupuesto total" />
                                <FaInfoCircle
                                    title="Es el monto total del periodo"
                                    style={{ marginLeft: '5px', color: 'rgb(0, 191, 188)', cursor: 'pointer' }}
                                />
                            </td>
                            <td style={{ padding: '10px', textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(totalAsignado)}</td>
                        </tr>
                        {relacion.modulo !== 'bases' && (
                            <tr>
                                <td style={{ padding: '10px', fontWeight: 'bold', textAlign: 'left', whiteSpace: 'nowrap' }}>
                                    <FormattedMessage id="presupuestoDetail.presupuesto_table.column_total_distribuido" defaultMessage="Presupuesto distribuido" />
                                    <FaInfoCircle
                                        title="Es el monto ya asignado a las subregiones o bases."
                                        style={{ marginLeft: '5px', color: 'rgb(0, 191, 188)', cursor: 'pointer' }}
                                    />
                                </td>
                                <td style={{ padding: '10px', textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(distribuido)}</td>
                            </tr>
                        )}
                        {relacion.modulo === 'bases' && (
                            <tr>
                                <td style={{ padding: '10px', fontWeight: 'bold', textAlign: 'left', whiteSpace: 'nowrap' }}>
                                    <FormattedMessage id="presupuestoDetail.presupuesto_table.column_total_comprometido" defaultMessage="Presupuesto comprometido" />
                                    <FaInfoCircle
                                        title="Es el monto total de los presupuestos de tickets aprobados sin cerrar"
                                        style={{ marginLeft: '5px', color: 'rgb(0, 191, 188)', cursor: 'pointer' }}
                                    />
                                </td>
                                <td style={{ padding: '10px', textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(comprometido)}</td>
                            </tr>
                        )}
                        {relacion.modulo === 'bases' && (
                            <tr>
                                <td style={{ padding: '10px', fontWeight: 'bold', textAlign: 'left', whiteSpace: 'nowrap' }}>
                                    <FormattedMessage id="presupuestoDetail.presupuesto_table.column_total_consumido" defaultMessage="Presupuesto consumido" />
                                    <FaInfoCircle
                                        title="Es el monto total de los presupuestos de tickets cerrados"
                                        style={{ marginLeft: '5px', color: 'rgb(0, 191, 188)', cursor: 'pointer' }}
                                    />
                                </td>
                                <td style={{ padding: '10px', textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(consumido)}</td>
                            </tr>
                        )}
                        <tr>
                            <td style={{ padding: '10px', fontWeight: 'bold', textAlign: 'left', whiteSpace: 'nowrap' }}>
                                <FormattedMessage id="presupuestoDetail.presupuesto_table.column_total_disponible" defaultMessage="Presupuesto disponible" />
                                <FaInfoCircle
                                    title={relacion.modulo !== 'bases'
                                        ? "Es la diferencia entre el monto total y el ya asignado a las subregiones o bases."
                                        : "Es la diferencia entre el monto total y la suma entre el monto comprometido y consumido"}
                                    style={{ marginLeft: '5px', color: 'rgb(0, 191, 188)', cursor: 'pointer' }}
                                />
                            </td>
                            <td style={{ padding: '10px', textAlign: 'left', whiteSpace: 'nowrap' }}>{formatCurrency(disponible)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

PresupuestoDetail.propTypes = {
    presupuesto: PropTypes.object.isRequired,
};

export default PresupuestoDetail;
